import { atom } from 'recoil';

const formulasState = atom({
  key: 'formulasState',
  default: {},
});

export default formulasState;
